import { Settings, Users, Shield, Database, Bell, Lock } from 'lucide-react';

const adminSections = [
  { name: 'User Management', description: 'Manage user roles and permissions', icon: Users },
  { name: 'Security Settings', description: 'Configure security and access controls', icon: Shield },
  { name: 'Database', description: 'Database configuration and backups', icon: Database },
  { name: 'Notifications', description: 'Manage notification preferences', icon: Bell },
  { name: 'API Keys', description: 'Manage API keys and integrations', icon: Lock },
  { name: 'General Settings', description: 'General application settings', icon: Settings },
];

export function Admin() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-2">Admin Panel</h1>
      <p className="text-muted-foreground mb-8">Administrative controls and system settings.</p>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {adminSections.map((section) => {
          const Icon = section.icon;
          return (
            <button
              key={section.name}
              className="glass-card p-6 rounded-xl text-left hover:border-primary/50 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <Icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-semibold mb-2">{section.name}</h3>
              <p className="text-sm text-muted-foreground">{section.description}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
